const UNIDADES = ['', 'um', 'dois', 'três', 'quatro', 'cinco', 'seis', 'sete', 'oito', 'nove',
  'dez', 'onze', 'doze', 'treze', 'quatorze', 'quinze', 'dezesseis', 'dezessete', 'dezoito', 'dezenove']

const DEZENAS = ['', '', 'vinte', 'trinta', 'quarenta', 'cinquenta', 'sessenta', 'setenta', 'oitenta', 'noventa']

const CENTENAS = ['', 'cento', 'duzentos', 'trezentos', 'quatrocentos', 'quinhentos',
  'seiscentos', 'setecentos', 'oitocentos', 'novecentos']

function grupoExtenso(n: number): string {
  if (n === 0) return ''
  if (n === 100) return 'cem'

  const c = Math.floor(n / 100)
  const r = n % 100
  const d = Math.floor(r / 10)
  const u = r % 10

  const partes: string[] = []

  if (c > 0) partes.push(CENTENAS[c])

  if (r > 0 && r < 20) {
    partes.push(UNIDADES[r])
  } else if (r >= 20) {
    if (u > 0) partes.push(`${DEZENAS[d]} e ${UNIDADES[u]}`)
    else partes.push(DEZENAS[d])
  }

  return partes.join(' e ')
}

export function valorPorExtenso(valor: number): string {
  if (valor === 0) return 'zero reais'

  const inteiro = Math.floor(Math.abs(valor))
  const centavos = Math.round((Math.abs(valor) - inteiro) * 100)

  const grupos: { divisor: number; singular: string; plural: string }[] = [
    { divisor: 1_000_000_000, singular: 'bilhão', plural: 'bilhões' },
    { divisor: 1_000_000, singular: 'milhão', plural: 'milhões' },
    { divisor: 1_000, singular: 'mil', plural: 'mil' },
    { divisor: 1, singular: '', plural: '' },
  ]

  const partes: string[] = []
  let rest = inteiro

  for (const g of grupos) {
    const q = Math.floor(rest / g.divisor)
    rest = rest % g.divisor
    if (q > 0) {
      const ext = grupoExtenso(q)
      if (g.divisor === 1) {
        partes.push(ext)
      } else if (q === 1) {
        partes.push(`${ext ? ext + ' ' : ''}${g.singular}`)
      } else {
        partes.push(`${ext} ${g.plural}`)
      }
    }
  }

  let resultado = ''
  if (inteiro > 0) {
    const reais = inteiro === 1 ? 'real' : 'reais'
    if (partes.length > 1) {
      const last = partes.pop()
      resultado = `${partes.join(', ')} e ${last} ${reais}`
    } else {
      resultado = `${partes[0]} ${reais}`
    }
  }

  if (centavos > 0) {
    const centExt = grupoExtenso(centavos)
    const centLabel = centavos === 1 ? 'centavo' : 'centavos'
    if (resultado) {
      resultado += ` e ${centExt} ${centLabel}`
    } else {
      resultado = `${centExt} ${centLabel}`
    }
  }

  return resultado
}

export function parseMonetaryValue(text: string): number | null {
  const cleaned = text.replace(/[R$\s.]/g, '').replace(',', '.')
  const num = parseFloat(cleaned)
  return isNaN(num) ? null : num
}
